/*
  Free-shipping progress bar animator.
  Dawn re-renders the cart drawer / cart page via the Section Rendering API on
  every cart change, replacing the bar's DOM wholesale. This script persists
  across those replacements: it watches for freshly injected bars, animates the
  fill from the previous value, pops the header cart icon, and fires a confetti
  celebration exactly when the free-shipping threshold is crossed.
*/
(() => {
  if (window.SFFreeShipBar) return;
  window.SFFreeShipBar = true;

  const COLORS = ['#ff6b35', '#ffb347', '#ffd76b', '#ffffff', '#ff8c5a'];
  const state = { total: null, pct: 0, reached: false };
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function burst(container, count, spread) {
    if (reducedMotion() || !container) return;
    for (let i = 0; i < count; i++) {
      const p = document.createElement('span');
      p.className = 'fsb-particle';
      const angle = Math.random() * 2 * Math.PI;
      const dist = spread * (0.4 + Math.random() * 0.9);
      p.style.setProperty('--tx', Math.cos(angle) * dist + 'px');
      p.style.setProperty('--ty', Math.sin(angle) * dist - spread * 0.35 + 'px');
      p.style.setProperty('--rot', Math.random() * 540 - 270 + 'deg');
      p.style.background = COLORS[i % COLORS.length];
      p.style.animationDelay = Math.random() * 0.15 + 's';
      if (Math.random() > 0.5) p.style.borderRadius = '50%';
      container.appendChild(p);
      setTimeout(() => p.remove(), 1500);
    }
  }

  function popIcon(unlocked) {
    const icon = document.getElementById('cart-icon-bubble');
    if (!icon || reducedMotion()) return;
    icon.classList.remove('fsb-pop', 'fsb-ring');
    void icon.offsetWidth; /* restart the animation */
    icon.classList.add('fsb-pop');
    if (unlocked) {
      icon.classList.add('fsb-ring');
      const holder = document.createElement('span');
      holder.className = 'fsb-icon-burst';
      icon.appendChild(holder);
      burst(holder, 10, 40);
      setTimeout(() => holder.remove(), 1600);
    }
    setTimeout(() => icon.classList.remove('fsb-pop', 'fsb-ring'), 2000);
  }

  function hydrate(bar) {
    if (bar.dataset.fsbHydrated) return;
    bar.dataset.fsbHydrated = '1';

    const total = parseInt(bar.dataset.total, 10) || 0;
    const pct = Math.min(parseFloat(bar.dataset.pct) || 0, 100);
    const reachedNow = bar.classList.contains('fsb--reached');
    const fill = bar.querySelector('.fsb__fill');

    const isFirstSighting = state.total === null;
    const changed = !isFirstSighting && state.total !== total;
    const crossedUp = !isFirstSighting && !state.reached && reachedNow;

    if (fill && !reducedMotion()) {
      const fromPct = isFirstSighting ? 0 : state.pct;
      fill.style.transition = 'none';
      fill.style.width = fromPct + '%';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          fill.style.transition = '';
          fill.style.width = pct + '%';
        });
      });
    }

    if (crossedUp) {
      /* slight delay so the drawer slide-in doesn't swallow the moment */
      setTimeout(() => burst(bar.querySelector('.fsb__confetti'), 26, 110), 250);
    }
    if (changed) popIcon(crossedUp);

    state.total = total;
    state.pct = pct;
    state.reached = reachedNow;
  }

  function scan(root) {
    if (root.nodeType !== 1) return;
    if (root.matches && root.matches('.free-shipping-bar')) hydrate(root);
    if (root.querySelectorAll) root.querySelectorAll('.free-shipping-bar').forEach(hydrate);
  }

  new MutationObserver((mutations) => {
    for (const m of mutations) for (const node of m.addedNodes) scan(node);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState !== 'loading') {
    scan(document.documentElement);
  } else {
    document.addEventListener('DOMContentLoaded', () => scan(document.documentElement));
  }
})();
